import { fromJS, Map, List, Record } from 'immutable';
const NAME_SPACE = 'KPI/';
const initialData = Map({});
const initialState = Map({
  loading: false,
  // data: List([]),
  // data: new Record({})
  data: Map({}),
  modify: Map({}),
});

const item = (state, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_INITIALSTATE':
      return initialState;
    case NAME_SPACE + 'MODIFY_KPISETTINGS':
      return state.update('modify', data => {
        // return data.push(action.payload.state);
        return action.payload;
      });
    case NAME_SPACE + 'RECEIVE_KPISETTINGS':
      return state.update('data', data => {
        return action.payload;
      })
    default:
      return state;
  };
}
const KPI = (state = initialState, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_INITIALSTATE':
      return item(undefined, action);
    case NAME_SPACE + 'MODIFY_KPISETTINGS':
      return item(state, action);
    case NAME_SPACE + 'RECEIVE_KPISETTINGS':
      return item(state, action);
    default:
      return state;
  }
};

export default KPI;
